import Config from 'lib/Config';
import moment from 'moment';
import { formatCurrency } from 'utils/currency';
import { now } from "utils/DateUtils";

export const renderData = (data, goal, DAYS) => {
    return {
        labels: DAYS ? DAYS.map(day => moment(day).format('Do')) : [],
        datasets: [
            {
                label: 'Last 7 Days',
                data: data,
                fill: true,
                backgroundColor: 'rgba(148, 247, 138, 0.5)',
                borderColor: '#94F78A',
                yAxisID: 'y1',
                pointRadius: 0,
                borderWidth: 2,
                datalabels: {
                    enabled: true,
                    backgroundColor: '#94F78A',
                    color: '#142643',
                    padding: {
                        top: 4,
                        bottom: 4,
                        left: 14,
                        right: 14
                    },
                    // align: 'top',
                    offset: 12,
                    borderRadius: 16,
                    font: {
                        family: 'Grotesk',
                        weight: 'bold'
                    }
                }
            },
            {
                label: 'Your Goal',
                data: new Array(now().daysInMonth()).fill(parseFloat(goal)),
                fill: true,
                borderColor: '#623FEA',
                backgroundColor: 'rgba(98, 63, 234, 0.5)',
                yAxisID: 'y2',
                pointRadius: 0,
                borderWidth: 2,
                datalabels: {
                    display: false
                }
            },
        ],
    }
}

export const renderOptions = (max, min, isPrice, DAYS) => {
    const buffer = 0.14;

    return {
        hover: {
            animationDuration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        showTooltips: false,
        layout: {
            padding: {
                left: 20,
                right: 20,
                top: 0,
                bottom: 0
            }
        },

        interaction: {
            mode: 'index',
            intersect: false
        },
        animation: {
            duration: Config.ANIMATE_GRAPH_DURATION
        },
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                formatter: function(value, context) {
                    let label = parseFloat(value);
                    if (isPrice === 'even') {
                        label = Math.floor(label);
                    } else if (isPrice === true) {
                        label = formatCurrency(label);
                    } else {
                        label = label.toFixed(2);
                    }

                    return label;
                },
                align: function(context) {
                    const index = context.dataIndex;
                    const value = parseFloat(context.dataset.data[index]);
                    let pos = (value - min) / (max - min);
                    if (pos < 0.8) {
                        return 'top';
                    } else {
                        return 'bottom';
                    }
                }
            },
            tooltip: {
                enabled: false,
                backgroundColor: 'rgba(255,255,255,1)',
                titleColor: '#142643',
                bodyColor: '#142643',
                footerColor: '#142643',
                xAlign: 'center',
                yAlign: 'top',
                padding: 7,
                position: 'average',
                callbacks: {
                    title: function(items) {
                        let index = items[0].dataIndex;
                        return DAYS ? moment(DAYS[index]).format('MMMM Do') : '';
                    },
                    label: function(item) {
                        let label = item.raw;

                        if (isPrice === 'even') {
                            label = Math.floor(parseFloat(label));
                        } else if (isPrice === true) {
                            label = formatCurrency(label);
                        } else {
                            label = parseFloat(label).toFixed(2);
                        }
                        return ` ${label}`;
                    }
                }
            }
        },
        elements: {
            line: {
                cubicInterpolationMode: 'monotone'
            }
        },
        scales: {
            y1: {
                display: false,
                position: 'left',
                min: min ? parseFloat(min) - (parseFloat(max) * buffer) : 0,
                max: parseFloat(max) + (parseFloat(max) * buffer),
            },
            y2: {
                display: false,
                min: min ? parseFloat(min) - (parseFloat(max) * buffer) : 0,
                max: parseFloat(max) + (parseFloat(max) * buffer),
            },
            x: {
                display: true,
                offset: true,
                ticks: {
                    align: 'center',
                    color: '#b4b4b4',
                },
                grid: {
                    drawTicks: false,
                    color: 'rgba(255, 255, 255, 0.2)'
                }
            }
        },
    }
}